import { useState } from "react";
import { X } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
const slides = [
  "/images/umrohcustom/umroh-edu01.jpg",
  "/images/umrohcustom/umroh-edu02.jpg",
];
const faqs = [
  {
    q: "Apa itu Umroh Custom?",
    a: "Program umroh yang dapat disesuaikan dengan kebutuhan jamaah, mulai dari jadwal keberangkatan, hotel, maskapai, hingga durasi perjalanan."
  },
  {
    q: "Apakah bisa berangkat hanya berdua?",
    a: "Bisa. Umroh Custom sangat cocok untuk pasangan, keluarga kecil, maupun grup terbatas."
  },
  {
    q: "Apakah bisa memilih hotel sendiri?",
    a: "Bisa. Tim Baba Tour akan membantu memberikan pilihan hotel sesuai kebutuhan dan anggaran Anda."
  },
  {
    q: "Apakah bisa memilih maskapai?",
    a: "Bisa. Kami dapat menyesuaikan pilihan maskapai sesuai preferensi dan ketersediaan jadwal."
  },
  {
    q: "Berapa harga Umroh Custom?",
    a: "Harga menyesuaikan pilihan hotel, maskapai, durasi perjalanan, dan jumlah peserta."
  }
];
export default function UmrohCustom() {
const [current, setCurrent] = useState(0);
const [openWA, setOpenWA] = useState(false);
const [openFaq, setOpenFaq] = useState(null);
  const msg = encodeURIComponent(
    "Assalamualaikum Baba Tour, saya ingin informasi Umroh Custom."
);
  return (
    <div className="bg-[color:var(--bg)] min-h-screen">
      <Header />
{openWA && (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
    <div className="bg-white rounded-2xl p-6 w-full max-w-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-lg">
          Pilih Kantor
        </h3>

        <button onClick={() => setOpenWA(false)}>
          <X className="w-5 h-5" />
        </button>
      </div>

      <a
        href={`https://wa.me/6282392156538?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        className="block w-full bg-green-500 text-white text-center rounded-xl py-3 mb-3"
      >
        📍 Batam
      </a>

      <a
        href={`https://wa.me/62811713309?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        className="block w-full bg-green-500 text-white text-center rounded-xl py-3"
      >
        📍 Palembang
      </a>
    </div>
  </div>
)}
<section className="pt-28 lg:min-h-[85vh] flex items-center">
<div className="max-w-4xl mx-auto px-6">
          <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
            Program Umroh Custom
          </div>

          <h1 className="font-serif-display text-primary text-5xl mt-4">
            Umroh Custom Baba Tour
          </h1>

          <p className="text-muted mt-6 text-lg leading-relaxed">
            Program Umroh Custom yang dirancang sesuai kebutuhan Anda.
Tentukan sendiri tanggal keberangkatan, pilihan maskapai,
hotel, serta durasi perjalanan untuk pengalaman ibadah yang
lebih fleksibel dan nyaman.
          </p>
<div className="mt-8">
  <div className="overflow-hidden rounded-3xl shadow-lg">
    <img
      src={slides[current]}
      alt={`Slide ${current + 1}`}
className="w-full lg:max-h-[420px] object-contain"
    />
  </div>

<div className="flex justify-center gap-4 mt-3">
    <button
      onClick={() =>
        setCurrent(current === 0 ? slides.length - 1 : current - 1)
      }
      className="px-5 py-2 border rounded-full"
    >
      ← Sebelumnya
    </button>

    <button
      onClick={() =>
        setCurrent(current === slides.length - 1 ? 0 : current + 1)
      }
      className="px-5 py-2 border rounded-full"
    >
      Berikutnya →
    </button>
  </div>
</div>
        </div>
      </section>
<section className="py-20">
  <div className="max-w-4xl mx-auto px-6">

    <h2 className="text-3xl font-bold text-center mb-10">
      Pertanyaan yang Sering Diajukan
    </h2>

    <div className="space-y-4">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="border rounded-2xl overflow-hidden"
        >
          <button
            onClick={() =>
              setOpenFaq(openFaq === index ? null : index)
            }
            className="w-full flex justify-between items-center p-5 text-left font-medium"
          >
            <span>{faq.q}</span>

            <span className="text-2xl">
              {openFaq === index ? "−" : "+"}
            </span>
          </button>

          {openFaq === index && (
            <div className="px-5 pb-5 text-muted">
              {faq.a}
            </div>
          )}
        </div>
      ))}
    </div>

  </div>
</section>
<section className="pt-2 pb-20">
  <div className="max-w-4xl mx-auto px-6 text-center">

    <h2 className="text-4xl font-bold text-primary mb-4">
      Siap Merencanakan Umroh Custom Anda?
    </h2>

    <p className="text-muted mb-8">
      Konsultasikan kebutuhan Umroh Custom Anda bersama tim Baba Tour.
    </p>

    <button
      onClick={() => setOpenWA(true)}
      className="bg-primary text-white px-8 py-4 rounded-full"
    >
      Konsultasi Umroh Custom
    </button>

  </div>
</section>
      <Footer />
    </div>
  );
}
